// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "*,:after,:before{margin:0;padding:0;box-sizing:border-box}code,pre{font-family:Roboto Mono,Monaco,courier,monospace;background-color:#f8f8f8;-webkit-font-smoothing:initial}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
